<template>
  <div class="room-device-setting-modal-component">
    <div class="room-device-setting-modal">
      <DeviceSettingPreview />
    </div>
  </div>
</template>

<script>
import DeviceSettingPreview from "@/components/Room/DeviceSetting/Preview";

export default {
  name: 'RoomDeviceSettingModal',
  components: {
    DeviceSettingPreview
  }
}
</script>

<style lang="scss" scoped>
.room-device-setting-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: grid;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 4;
  overflow-y: auto;
}
.room-device-setting-modal {
  width: 372px;
  height: 806px;
  border-radius: 12px;
  background-color: #fff;
  overflow: hidden;
}

// Mobile
[grm-device-mobile] {
  .room-device-setting-modal-component {
    display: flex;
  }
  .room-device-setting-modal {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>